//automatically installed with react router dom1
import { createBrowserHistory as createHistory } from "history";

export default createHistory();